import type { SearchData } from "../../types";
import type {
  CourtOptionPaginationControls,
  SearchOption,
} from "../../types/searchSessions";
import CourtSelectField from "./CourtSelectField";

interface DistrictCourtSessionFieldsProps {
  searchData: Pick<
    SearchData,
    "state" | "district" | "courtComplex" | "establishment" | "courtName"
  >;
  states: SearchOption[];
  districts: SearchOption[];
  complexes: SearchOption[];
  establishments: SearchOption[];
  courtRooms: SearchOption[];
  courtEstablishment?: boolean;
  onInputChange: (field: keyof SearchData, value: string) => void;
  disabled?: boolean;
  standalone?: boolean;
  controls?: CourtOptionPaginationControls;
}

const DistrictCourtSessionFields = ({
  searchData,
  states,
  districts,
  complexes,
  establishments,
  courtRooms,
  courtEstablishment,
  onInputChange,
  disabled = false,
  standalone = true,
  controls = {},
}: DistrictCourtSessionFieldsProps) => {
  const fields = (
    <>
      <CourtSelectField
        id="state"
        label="State"
        options={states}
        value={searchData.state}
        onChange={(value) => onInputChange("state", value)}
        disabled={disabled}
        placeholder="Select State"
      />
      <CourtSelectField
        id="district"
        label="District"
        options={districts}
        value={searchData.district}
        onChange={(value) => onInputChange("district", value)}
        disabled={disabled || !searchData.state}
        placeholder="Select District"
        paginationControl={controls.districts}
      />
      <CourtSelectField
        id="complex"
        label="Court Complex"
        options={complexes}
        value={searchData.courtComplex}
        onChange={(value) => onInputChange("courtComplex", value)}
        disabled={disabled || !searchData.district}
        placeholder="Select Court Complex"
        paginationControl={controls.complexes}
      />
      {courtEstablishment && (
        <CourtSelectField
          id="court-establishment"
          label="Establishment"
          options={establishments}
          value={searchData.establishment}
          onChange={(value) => onInputChange("establishment", value)}
          disabled={disabled || !searchData.courtComplex}
          placeholder="Select Establishment"
          paginationControl={controls.establishments}
        />
      )}
      <CourtSelectField
        id="court-room"
        label="Court Room"
        options={courtRooms}
        value={searchData.courtName}
        onChange={(value) => onInputChange("courtName", value)}
        disabled={
          disabled ||
          !searchData.courtComplex ||
          (Boolean(courtEstablishment) && !searchData.establishment)
        }
        placeholder="Select Court Room"
        paginationControl={controls.courtRooms}
      />
    </>
  );

  if (!standalone) {
    return fields;
  }

  return <div className="grid grid-cols-1 md:grid-cols-3 gap-3">{fields}</div>;
};

export default DistrictCourtSessionFields;
